import React from 'react';
import { Link, withRouter } from "react-router-dom";
import { Typography } from '../../index';

export const NavigationItemLink = ({
    index,
    navItem,
    isSelectedLink = () => { },
    onItemClick = () => { },
    selected,
    toggleMainMenu = () => { }
}) => {

    const altUrls = navItem?.altUrls ? navItem?.altUrls : null;
    const isSelected = typeof selected === "boolean" ? selected : isSelectedLink(navItem?.url, altUrls);
    const isDisabled = navItem?.disabled;
    const navItemLinkClasses = [
        `bsw-navigation__link`,
        `${isSelected ? 'selected' : ''}`,
        `${isDisabled ? 'disabled' : ''}`,
        `${navItem?.className ? navItem?.className : ''}`
    ].join(' ');
    const textColor = isDisabled
        ? isSelected ? '$color-secondary-a3' : '$color-secondary-a4'
        : isSelected ? '$color-primary-a3' : '$color-secondary-a2';

    const label = navItem.label;

    return <>
        {navItem?.url
            ? <Link
                onClick={(e) => {
                    onItemClick(e, index, label);
                    toggleMainMenu();
                }}
                to={{ pathname: navItem.url }}
                target={navItem.target ? navItem.target : null}
                className={navItemLinkClasses}
            >
                <Typography
                    type="body-02"
                    bold={isSelected}
                    color={textColor}
                >
                    {label}
                </Typography>
            </Link>
            : <button
                onClick={(e) => {
                    onItemClick(e, index, label);
                }}
                type="button"
                className={navItemLinkClasses}
                disabled={isDisabled}
            >
                <Typography
                    type="body-02"
                    bold={isSelected}
                    color={textColor}
                >
                    {label}
                </Typography>
            </button>
        }
    </>
}
